import { createFeatureSelector, createSelector } from '@ngrx/store';
import { projectsFeatureKey, ProjectsState, selectAll } from './projects.reducer';
import { PROJECT_STATUS_KEY } from '@app/pages/webapp/projects/projects.interface';

export const selectProjectsState = createFeatureSelector<ProjectsState>(projectsFeatureKey);
export const selectAllProjects = createSelector(selectProjectsState, selectAll);

export const selectAllSimpleProjects = createSelector(
  selectProjectsState,
  (state) => state.simpleProjects,
);

export const selectNonDeletedSimpleProjects = createSelector(
  selectAllSimpleProjects,
  (projects) => {
    return projects.filter((project) => {
      const status = project?.project_status?.key;
      return status !== PROJECT_STATUS_KEY.DELETED && status !== PROJECT_STATUS_KEY.ARCHIVED;
    });
  },
);

export const selectAreSimpleProjectsLoading = createSelector(
  selectProjectsState,
  (state) => state.areSimpleProjectsLoading,
);

export const selectIsEditProjectLoading = createSelector(
  selectProjectsState,
  (state) => state.isEditProjectLoading,
);

export const selectProjectStatuses = createSelector(selectProjectsState, (state) => state.statuses);

export const selectProjectStatusesExcept = (filterStatuses: PROJECT_STATUS_KEY[]) =>
  createSelector(selectProjectStatuses, (allStatuses) =>
    allStatuses.filter((s) => !filterStatuses.includes(s.key)),
  );

export const selectProjectStatusesByKey = (keys: PROJECT_STATUS_KEY[]) =>
  createSelector(selectProjectStatuses, (allStatuses) =>
    allStatuses.filter((s) => keys.includes(s.key)),
  );

export const selectMentionProjects = createSelector(selectNonDeletedSimpleProjects, (projects) => {
  return projects.map((project) => ({
    id: project.id,
    name: project.title,
  }));
});
